import { ProjectKind } from "../../../enums/ProjectKind";

export const pluralizeKind = (kind: ProjectKind) => {
  return kind === ProjectKind.Film ? "f" : "s";
};
